module.exports = __webpack_public_path__ + "static/media/GloberSemiBold.7976402f.woff";